import { formatNumber } from "@/Modules/utils/useFormatNumber";

export const commonChart = {
  background: "transparent",
  toolbar: { show: false },
  fontFamily: "system-ui, -apple-system, sans-serif",
  animations: {
    enabled: true,
    easing: "easeinout",
    speed: 800,
    animateGradually: {
      enabled: true,
      delay: 150,
    },
    dynamicAnimation: {
      enabled: true,
      speed: 350,
    },
  },
  zoom: { enabled: false },
};

export const commonGrid = {
  borderColor: "#f1f5f9",
  strokeDashArray: 0,
  xaxis: { lines: { show: false } },
  yaxis: { lines: { show: true } },
  padding: {
    left: 20,
    right: 0,
    top: 0,
    bottom: 0,
  },
};

export const commonXAxisLabels = {
  style: {
    colors: "#64748b",
    fontSize: "13px",
    fontWeight: 500,
  },
  offsetY: 5,
};

export const commonYAxis = {
  labels: {
    style: {
      colors: "#64748b",
      fontSize: "13px",
      fontWeight: 500,
    },
    formatter: (val) => Math.round(val).toString(),
  },
  min: 0,
  max: function (max) {
    return max * 1.1;
  },
  forceNiceScale: true,
};

export function buildCommonTooltip(legendItems, colors) {
  return {
    theme: "light",
    shared: true,
    intersect: false,
    style: {
      fontSize: "14px",
    },
    custom: ({ series, dataPointIndex, w }) => {
      const label =
        w.globals.categoryLabels?.[dataPointIndex] ??
        w.globals.labels?.[dataPointIndex] ??
        w.globals.seriesX?.[0]?.[dataPointIndex] ??
        "";
      let content = `<div class="custom-tooltip">
    <div class="tooltip-time">${label}</div>`;
      series.forEach((seriesData, index) => {
        const value = seriesData[dataPointIndex];
        if (value != null && value !== 0) {
          const color = colors[index];
          const name = legendItems[index]?.name || w.globals.seriesNames[index];
          const formattedValue = formatNumber(value); // Use your formatNumber method
          content += `
        <div class="tooltip-item">
          <span class="tooltip-dot" style="background-color: ${color}"></span>
          <span class="tooltip-label">${name}:</span>
          <span class="tooltip-value">${formattedValue}</span>
        </div>`;
        }
      });
      content += "</div>";
      return content;
    },
  };
}
